<template>
    <ul class="navigation">
        <router-link tag="li" active-class="navigation__active" :to="{name: 'dashboard'}">
            <a>Home</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'associations.browse'}">
            <a>Associations</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'crop-types.browse'}">
            <a>Crop Types</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'packages.browse'}">
            <a>Packages</a>
        </router-link>

        <router-link tag="li" active-class="navigation__active" :to="{name: 'processors.browse'}">
            <a>Processors</a>
        </router-link>

        <li class="navigation__sub" :class="{'navigation__sub--active': isActiveItem('/users')}">
            <b-link @click="toggleUsers">Users</b-link>

            <keep-alive>
                <ul v-if="showUsers" class="animated">
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse'}" exact>
                        <a>All Users</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse', params: {role: 'admin'}}" exact>
                        <a>Admins</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse', params: {role: 'contractor'}}" exact>
                        <a>Contractors</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse', params: {role: 'grower'}}" exact>
                        <a>Growers</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse', params: {role: 'processor'}}" exact>
                        <a>Processor Representatives</a>
                    </router-link>
                    <router-link tag="li" active-class="navigation__active" :to="{name: 'users.browse', params: {role: 'association'}}" exact>
                        <a>Association Representatives</a>
                    </router-link>
                </ul>
            </keep-alive>
        </li>

        <li class="navigation__sub" :class="{'navigation__sub--toggled': showExtra}" v-if="showAssociationTools">
            <a href="" @click.prevent="showExtra = !showExtra">Association Tools</a>

            <ul v-show="showExtra" class="animated">
                <router-link tag="li" active-class="navigation__active" :to="{name: 'crop-types.browse'}">
                    <a>Crop Types</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-targets.browse'}">
                    <a>Chemical Targets</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-classifications.browse'}">
                    <a>Chemical Classifications</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-commercial-variants.browse-non-grouped'}">
                    <a>Commercial Chemicals</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'chemical-active-ingredients.browse'}">
                    <a>Chemical Active Ingredients</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'fertilisers.browse'}">
                    <a>Fertilisers</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'fertiliser-additives.browse'}">
                    <a>Fertiliser Additives</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'countries.browse'}">
                    <a>Countries &amp; Regions</a>
                </router-link>

                <router-link tag="li" active-class="navigation__active" :to="{name: 'withholding-periods.browse'}">
                    <a>Withholding Periods</a>
                </router-link>
            </ul>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'AdminAppSidebar',
  props: ['user'],
  apollo: {},
  data() {
    return {
      showExtra: false,
      showUsers: this.isActiveItem('/users'),
      loading: 0,
    };
  },
  computed: {
    showAssociationTools(){
      return this.user.role.name === 'developer';
    },
  },
  methods: {
    isActiveItem(url) {
      return this.$route.path.startsWith(url);
    },
    toggleUsers() {
      this.showUsers = !this.showUsers;
    }
  },
};
</script>
